let enabledKey = 'up.log.enabled';
let enabled = false;
try {
    enabled = !!(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(enabledKey));
}
catch (_a) {
}
up.LogConfig = class LogConfig extends up.Config {
    constructor() {
        super(() => ({
            banner: true,
            format: true,
        }));
    }
    get enabled() {
        return enabled;
    }
    set enabled(newEnabled) {
        enabled = newEnabled;
        try {
            sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(enabledKey, newEnabled ? '1' : '');
        }
        catch (_a) {
        }
    }
};
